import { render, staticRenderFns } from "./CompanyDash.vue?vue&type=template&id=1fa2f6d6&scoped=true&"
import script from "./CompanyDash.vue?vue&type=script&lang=js&"
export * from "./CompanyDash.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDash.vue?vue&type=style&index=0&id=1fa2f6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2f6d6",
  null
  
)

export default component.exports